export function calculateActualMinimumQuantity(minimumOrderQuantity, caseQuantity) {
    const minOrderQuantity = Math.max(1, +minimumOrderQuantity || 0)
    const caseQuantityValue = Math.max(1, +caseQuantity || 0)

    return minOrderQuantity > caseQuantityValue
        ? Math.ceil(minOrderQuantity / caseQuantityValue) * caseQuantityValue
        : Math.max(minOrderQuantity, caseQuantityValue)
}

export function roundQuantityUpToCaseMultiple(quantity, caseQuantity) {
    const caseQuantityValue = Math.max(1, +caseQuantity || 0)
    return Math.ceil((+quantity || 0) / caseQuantityValue) * caseQuantityValue
}

export function isVariantAvailableForPurchase(inventory, inventoryPolicy, minimumOrderQuantity, caseQuantity) {
    if (inventoryPolicy === 'CONTINUE') return true
    if ((+inventory || 0) <= 0) return false
    return (+inventory || 0) >= calculateActualMinimumQuantity(minimumOrderQuantity, caseQuantity)
}

export function calculateInitialQuantity(minimumOrderQuantity, caseQuantity) {
    return calculateActualMinimumQuantity(minimumOrderQuantity, caseQuantity)
}

export function isContinueInventoryPolicy(inventoryPolicy) {
    return inventoryPolicy === 'CONTINUE'
}
